/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundErrorComponent } from '../main/error-page/not-found-error/not-found-error';
import { LayoutComponent } from './layout.component';
import { RouterSegments } from '../models/router-segments';
import { DashboardComponent } from '../main/dashboard/dashboard.component';
import { FaqSectionComponent } from '../components/faq-section/faq-section.component';

const routes: Routes = [{
  path: '',
  component: LayoutComponent,
  children: [{
    path: '',
    data: {
      title: 'Temenos Banking Cloud Portal'
    },
    loadChildren: () => import('src/app/main/dashboard/dashboard.module').then(m => m.DashboardModule)
  }, {
    path: 'catalogue',
    data: {
      title: 'Catalogue'
    },
    component: NotFoundErrorComponent
    // loadChildren: () => import('src/app/main/catalogue/catalogue.module').then(m => m.CatalogueModule)
  }, {
    path: 'compose',
    data: {
      title: 'Compose Service'
    },
    component: NotFoundErrorComponent
    // loadChildren: () => import('src/app/main/service/compose-service/compose-service.module').then(m => m.ComposeServiceModule)
  }, {
    path: 'composable-banking',
    loadChildren: () => import('src/app/main/service/composable-banking/composable-banking.module').then(m => m.ComposableBankingModule)
  }, {
    path: 'downloads',
    data: {
      title: 'Downloads'
    },
    component: NotFoundErrorComponent
    // loadChildren: () => import('src/app/main/download-iac-request-list/download-iac-request-list.module')
    // .then(m => m.DownloadIacRequestListModule)
  }, {
    path: 'services',
    children: [{
      path: '',
      component: NotFoundErrorComponent,
      pathMatch: 'full'
    }, 
    {
      path: ':serviceId',
      component: NotFoundErrorComponent,
      pathMatch: 'full',
      // loadChildren: () => import('src/app/main/service/blueprint-summary/blueprint-summary.module').then(m => m.BlueprintSummaryModule)
    },{
      path: '',
      loadChildren: () => import('src/app/main/service/service-summary/service-summary.module').then(m => m.ServiceSummaryModule)
    }, {
      path: ':serviceId/blueprints/:blueprintId',
      loadChildren: () => import('src/app/main/service/blueprint-summary/blueprint-summary.module').then(m => m.BlueprintSummaryModule)
    }, {
      path: ':serviceId/blueprints/:blueprintId/Sandbox',
      loadChildren: () => import('src/app/main/service/byob-blueprint-summary/byob-blueprint-summary.module')
        .then(m => m.ByobBlueprintSummaryModule)
    }, {
      path: ':serviceId/extend/:blueprintId',
      loadChildren: () => import('src/app/main/service/service-definition-version/service-definition-version.module')
        .then(m => m.ServiceDefinitionVersionModule)
    }, {
      path: ':serviceId',
      loadChildren: () => import('../main/service/service-definition/service-definition.module').then(m => m.ServiceDefinitionModule)
    },
    {
      path: ':serviceId',
      component: NotFoundErrorComponent
      // loadChildren: () => import('../main/service/download-iac/download-iac.module').then(m => m.DownloadIacModule)
    }
  ],
  }, {
    path: 'my-sandbox',
    loadChildren: () => import('src/app/main/my-sandbox/my-sandbox.module').then(m => m.MySandboxModule)
  }, {
    path: 'my-services',
    data: {
      title: 'My Services'
    },
    loadChildren: () => import('src/app/main/view-my-services/view-my-services.module').then(m => m.ViewMyServicesModule)
  }, {
    path: 'inspiration-lounge',
    data: {
      title: 'Inspiration Lounge'
    },
    component: NotFoundErrorComponent
    // loadChildren: () => import('src/app/main/inspiration-lounge/inspiration-lounge.module').then(m => m.InspirationLoungeModule)
  }, {
    path: 'audit-trail',
    data: {
      title: 'Audit Trail'
    },
    component: NotFoundErrorComponent
    // loadChildren: () => import('src/app/main/audit-trail/audit-trail.module').then(m => m.AuditTrailModule)
  },
  {
    path: 'permission-unauthorized',
    loadChildren: () => import('src/app/main/permission-unauthorized/permission-unauthorized.module')
      .then(m => m.PermissionUnauthorizedModule),
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('src/app/main/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
  },
  {
    path: 'error',
    loadChildren: () => import('src/app/main/error-page/error-page.module').then(m => m.ErrorPageModule)
  },
  {
    path: RouterSegments.SETTINGS,
    data: {
      title: 'Settings'
    },
    loadChildren: () => import('src/app/main/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'faq',
    component: FaqSectionComponent
  },
  {
    path: '**',
    data: {
      title: '404 not Found'
    },
    component: NotFoundErrorComponent
  }
]

}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
